import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Root } from "./Root.js";
import "./index.css";

const container = document.getElementById("root");

if (container === null) {
  throw new Error("#root is missing from index.html");
}

// `/login` and `/auth/callback` render outside the ordering context (ORDR-63);
// every other address goes through OrderingContextProvider, as before.
createRoot(container).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
